import { isEmpty } from 'helpers/isEmpty'
import { filterEmpty } from 'helpers/object'
import { OrderYarcheCreateDestinationPartner, OrderYarcheCreateRequest } from 'schema'

import { OrderYarcheCreateFormData } from './types'

export const prepareOrderYarcheCrateData = ({
  destinationPartner,
  destinationPoint,
  departurePoint,
  ...rest
}: OrderYarcheCreateFormData): OrderYarcheCreateRequest => {
  const data = {
    ...rest
  } as OrderYarcheCreateRequest

  if (!isEmpty(destinationPartner?.contact)) {
    data.destinationPartner = {
      ...destinationPartner,
      contact: filterEmpty(destinationPartner?.contact)
    } as OrderYarcheCreateDestinationPartner
  }

  if (departurePoint?.terminalId) {
    data.departurePoint = {
      terminalId: departurePoint.terminalId
    }
  }

  if (destinationPoint?.terminalId) {
    data.destinationPoint = {
      terminalId: destinationPoint.terminalId
    }
  }

  return data
}
